<template>
  <div class="wrapper">
    <!-- <item-detail :detail="detail" :detailShow="detailShow"></item-detail> -->
    <div class="common-detail" v-for="(itemBig,index) in detail" :key="index" v-cloak>
      <div class="title">{{itemBig.title}}</div>
      <div class="article-content ql-editor" v-html="itemBig.content"></div>
      <div class="article-content">
        <div v-for="(item,index) in itemBig.files" :key="index">
         <p class="ql-file"> <a :href="item.url">{{item.name}}</a></p>
        </div>
      </div>
      <div class="con-line" v-if="index<detail.length - 1">
        </div>
    </div>
<!-- <div class="con-line" v-if="detail.title2">

</div>
    <div class="common-detail" v-cloak v-if="detail.title2">
      <div class="title">{{detail.title2}}</div>
      <div class="article-content ql-editor" v-html="detail.content2"></div>
      <div class="article-content">
        <div v-for="(item,index) in detail.file_url2" :key="index">
          <a :href="item.url">{{item.name}}</a>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import itemDetail from "@/components/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      detailShow: false,
      detail: {}
    };
  },
  computed: {},
  mounted() {
    this.conDetail();
  },
  methods: {
    ...mapActions(["firstTitle"]),
    toPage(url) {
      this.$router.push(url);
    },
    conDetail() {
      if (this.$route.query.type == 1) {
        this.firstTitle("计量检测委托业务");
      } else {
        this.firstTitle("质量管理信息填报");
      }
      userApi.multipleinfo({ type: this.$route.query.type }).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    itemDetail
  },
  watch: {
    $route() {
      this.conDetail();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../common/minix.less";
.wrapper {
  padding: 20 / @rem;
  box-sizing: border-box;
  background: #f2f2f2;
}
.con-line{
  width: 100%;
  height: 2px;
  background: #dcdcdc;
  margin: 50/@rem auto;
}
.common-detail .title {
  font-size: 36 / @rem;
  color: #222;
  text-align: center;
  margin-bottom: 20 / @rem;
  font-weight: 600;
  line-height: 56 / @rem;
}
.article-content {
  font-size: 30 / @rem;
  line-height: 50 / @rem;
}
.article-content /deep/ p {
  // margin-bottom: 20 / @rem;
}
.article-content /deep/ h1 {
  font-size: 48 / @rem;
  margin-bottom: 20 / @rem;
}
.article-content /deep/ h2 {
  font-size: 44 / @rem;
  margin-bottom: 20 / @rem;
  font-weight: 600;
}
.article-content /deep/ h3 {
  font-size: 36 / @rem;
  margin-bottom: 20 / @rem;
  font-weight: 600;
}
.article-content /deep/ h4 {
  font-size: 32 / @rem;
  margin-bottom: 20 / @rem;
  font-weight: 600;
}
.article-content /deep/ h5 {
  font-size: 27 / @rem;
  margin-bottom: 20 / @rem;
  font-weight: 600;
}
.article-content /deep/ h6 {
  font-size: 25 / @rem;
  margin-bottom: 20 / @rem;
  font-weight: 600;
}
.article-content /deep/ img {
  width: 100%;
  display: block;
  margin: 0 auto 20 / @rem;
}
.article-content /deep/ video {
  width: 100%;
  display: block;
  margin: 0 auto 20 / @rem;
}
.ql-file{
  padding: 8/@rem 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/conUs/multipleinfo.vue